<template>
    <div>
        <div id="supportWidgetLauncher" :class="classSupportWidgetLauncher">
            <div class="innerWrapper">
                <img src="/images/support-widget-icon.png" width="50px" height="50px" alt="" class="iconOpen" @click="openSupportWidget">
                <img src="/images/support-widget-icon-close.png" width="50px" height="50px" alt="" class="iconClose" @click="closeSupportWidget">
            </div>
        </div>

        <div id="supportWidgetInterface" v-show="showSupportWidgetInterface">
            <div class="innerWrapper">
                <div class="sectionFaq">
                    <h4>{{ lang.sectionFaqHeadline }}</h4>
                    <a role="button" class="btn btn-default btn-block jsBtnSupportWidgetGoToFaq" href="https://blog.used-design.com/hilfe/" target="_blank"><span class="glyphicon glyphicon-education" aria-hidden="true"></span> {{ lang.faqBtnLabel }}</a>
                </div>

                <div class="sectionSupportTicket">
                    <h4>{{ lang.sectionSupportTicketHeadline }}</h4>
                    <form action="" id="supportWidgetTicketForm" v-show="responseMsg === ''">
                        <div class="form-group" :class="{ 'has-error': formErrors.has('subject'), errorShake: formErrors.has('subject') && shakeOnError }">
                            <input
                                type="text"
                                class="form-control"
                                v-model="subject"
                                :placeholder="lang.labels.subject + ' *'"
                                :disabled="disableForm"
                                required
                            >
                        </div>
                        <div class="form-group" :class="{ 'has-error': formErrors.has('msg'), errorShake: formErrors.has('msg') && shakeOnError }">
                            <textarea
                                class="form-control"
                                rows="3"
                                v-model="msg"
                                :placeholder="lang.labels.msg + ' *'"
                                :disabled="disableForm"
                                required
                            ></textarea>
                        </div>
                        <div class="form-group" :class="{ 'has-error': formErrors.has('name'), errorShake: formErrors.has('name') && shakeOnError }">
                            <input
                                type="text"
                                class="form-control"
                                v-model="name"
                                :placeholder="lang.labels.name + ' *'"
                                :disabled="disableForm"
                                required
                            >
                        </div>
                        <div class="form-group" :class="{ 'has-error': formErrors.has('email'), errorShake: formErrors.has('email') && shakeOnError }">
                            <input
                                type="email"
                                class="form-control"
                                v-model="email"
                                :placeholder="lang.labels.email + ' *'"
                                :disabled="disableForm"
                                required
                            >
                        </div>
                        <br>
                        <button type="button" class="btn btn-default btn-block" @click="submitForm"><span class="glyphicon glyphicon-envelope" aria-hidden="true"></span> {{ lang.labels.sendBtn }}</button>
                    </form>
                    <h4 style="margin-top:50px" v-show="responseMsg !== ''">{{ responseMsg }}</h4>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import FormErrors from './../../FormErrors.js';

const props = defineProps({
    initName: {
        type: String,
        default: ''
    },
    initEmail: {
        type: String,
        default: ''
    },
    lang: {
        type: Object,
        required: true
    }
});

const showSupportWidgetInterface = ref(false);
const subject = ref('');
const msg = ref('');
const name = ref(props.initName);
const email = ref(props.initEmail);
const responseMsg = ref('');
const disableForm = ref(false);
const shakeOnError = ref(true);
const formErrors = ref(new FormErrors());

const classSupportWidgetLauncher = computed(() => ({
    'closed': !showSupportWidgetInterface.value,
    'active': showSupportWidgetInterface.value,
}));

const openSupportWidget = () => {
    showSupportWidgetInterface.value = true;

    // track event
    const category = 'support widget';
    const action = 'open';
    const label = window.location.pathname;
    window.trackGAEvent?.(category, action, label);
};

const closeSupportWidget = () => {
    showSupportWidgetInterface.value = false;
};

const validateForm = () => {
    formErrors.value.clear();
    shakeOnError.value = true;
    const errors = {};

    if (subject.value === '' || subject.value === null) errors.subject = 'missing';
    if (msg.value === '' || msg.value === null) errors.msg = 'missing';
    if (name.value === '' || name.value === null) errors.name = 'missing';
    if (email.value === '' || email.value === null) errors.email = 'missing';

    formErrors.value.record(errors);

    if (formErrors.value.any()) {
        setTimeout(() => {
            shakeOnError.value = false;
        }, 500);
        return false;
    }

    return true;
};

const submitForm = () => {
    disableForm.value = true;
    const validation = validateForm();

    if (validation) {
        axios.post('/web-api/contact/msg', {
            subject: subject.value,
            msg: msg.value,
            name: name.value,
            email: email.value,
        })
            .then(response => {
                responseMsg.value = response.data.msg;
            })
            .catch(() => {
                // error handling
            });
    } else {
        disableForm.value = false;
    }
};
</script>
